import React from 'react'
import {Link} from 'react-router-dom'
import {useSelector} from 'react-redux'
import {isNil} from 'lodash/fp'
import ListGroup from 'jbc-front/components/ListGroup'
import {connectPager} from 'components/paginators'
import {connectPerPage} from 'components/PerPage'
import connectListData from 'components/ListData'
import Loading from 'components/Loading'
import {EmptyListItem, ListItem} from 'tm/notifications/Inbox'
import {getQueryDiff} from 'tm/notifications/reducers'
import {actionCreators} from 'actions'
import api from 'api'
import styles from './Inbox.scss'

const querySelector = (state) => state.tm.notifications.query
const queryActionSelector = actionCreators.tm.notifications.setQuery

const Pager = connectPager(querySelector, queryActionSelector)
const PerPage = connectPerPage(querySelector, queryActionSelector)
const loadList = (token, query) => api.createWithAuth(token).tm.notifications.inbox(query)
const ListData = connectListData(querySelector, actionCreators.tm.notifications, loadList, getQueryDiff)

const SentAll = () => {
  const [loading, notifications, count, status] = useSelector((state) => [
    state.tm.notifications.list.loading,
    state.tm.notifications.list.data,
    state.tm.notifications.list.count,
    state.tm.notifications.status.data,
  ])

  // ステータスチェックか一覧取得のどちらか応答の早い方で未回答を検出した時点で、メッセージを出す
  const hasUnanswered =
    (status?.unanswered_count && status.unanswered_count > 0) ||
    notifications?.some((n) => isNil(n.answer?.selected_option_id))

  return (
    <div>
      <ListData />
      <div className="l-main-title-wrap u-pb0">
        <h1 className="m-title-main u-pb40">受信した通知一覧</h1>
      </div>
      <div className="l-wrap-xl l-contents-wrap">
        <div className="l-breadcrumb u-mb30">
          <Link to="/tm/notifications/inbox" className="l-breadcrumb-link">
            従業員通知
          </Link>
          <span className="l-breadcrumb-here">受信した通知一覧</span>
        </div>
        <ListGroup>
          <ListGroup.Title>
            <span>受信した通知</span>
            {hasUnanswered && <span className={styles.unansweredHeader}>未回答あり</span>}
          </ListGroup.Title>
          {loading ? (
            <ListGroup.Item>
              <Loading />
            </ListGroup.Item>
          ) : notifications.length > 0 ? (
            notifications.map((notification) => <ListItem key={notification.id} notification={notification} />)
          ) : (
            <EmptyListItem />
          )}
        </ListGroup>
        <div className="m-pager-area">
          <Pager totalResult={count} pageLinks={7} />
          <PerPage />
        </div>
      </div>
    </div>
  )
}

export default SentAll
